// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ColoredBackground__Wrapper_2LycO"};